import AcceptanceStatusBand from "./AcceptanceStatusBand";
import DocumentStatusBand from "./DocumentStatusBand";

export { AcceptanceStatusBand, DocumentStatusBand };



// WEBPACK FOOTER //
// ./src/components/DocumentV2/StatusBands/index.js